import { MUTATION_TYPES } from './types';

const mutations = {
  setMoreRows(state) {
    state.results = {
      ...state.results,
      data: [...state.results.data, ...state.results.chunked[0]],
    };
    state.results.chunked.shift(0);
  },
  [MUTATION_TYPES.SET_ACADEMICYEARS](state, payload) {
    state.catalog.compuAcademicYears = payload;
  },

  [MUTATION_TYPES.SET_MEETINGTYPES](state, payload) {
    state.catalog.meetingTypes = payload;

    //para las discusiones de evaluación.
    state.catalog.meetingTypes.push({
      id: 7,
      name: 'Discusión de Evaluación',
    });
  },

  [MUTATION_TYPES.SET_RESULTS_FILTERED](state, payload) {
    state.results = {
      data: payload.length > 0 ? payload[0] : [],
      chunked: payload.length > 0 ? payload.slice(1) : [[]],
    };
  },
};

export default mutations;
